import InnerBox from '@repo/ui/inner-box'
import { useFormContext } from 'react-hook-form'

import { CseInput } from '../../../lib/types/models/cse/cse'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'

const CseNumberOfEmployeesFormSection = () => {
  const form = useFormContext<CseInput>()

  return (
    <InnerBox title="Nombre de salariés" className="rounded-xl">
      <FormField
        control={form.control}
        name="numberOfEmployees"
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <ControlledInput {...field} type="number" placeholder="0" />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default CseNumberOfEmployeesFormSection
